import z from 'zod';

export const isPhoneNumberValid = (phoneNumber: string) =>
  z
    .string()
    .regex(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)
    .safeParse(phoneNumber).success;
